import { useState } from 'react';
import { useOnMount } from '../../hooks/useOnMount';
import { mergeDeep } from '../../utils/mergeDeep';
import { HeaderStandaloneProps } from '../types/headerStandalone';
import { EventData, generateWWEvents } from '../WWEvents';
import { ClubLink, ClubLinksType } from '../types/clubLinksTypes';

const fetchExternalProps = async (endpoint: string): Promise<HeaderDataRequest['metadata']> => {
    const req = await fetch(endpoint);
    const res: HeaderDataRequest = await req.json();
    if (!res.success) {
        throw new Error(`Error while fetching header data: ${JSON.stringify([...res.errors, ...res.internal_errors])}`);
    }

    const props = res.metadata;
    return props;
};

export const useExternalProps = (
    props: HeaderStandaloneProps,
    links: ClubLinksType,
    shouldFetchData = false
): HeaderStandaloneProps => {
    const [externalProps, setExternalProps] = useState<HeaderStandaloneProps>(props);

    useOnMount(() => {
        if (!shouldFetchData) {
            return;
        }

        fetchExternalProps(links[ClubLink.CUSTOMER_ACCOUNT_HEADERDATA].path)
            .then(({ seo, ...fetchedProps }) => {
                const WWEvents = generateWWEvents();
                WWEvents.fire('USER_LOADED', seo);
                return mergeDeep(props, fetchedProps);
            })
            .then(setExternalProps)
            .catch(err => {
                props.logger.error(err);
            });
    });

    return externalProps;
};

type HeaderDataRequest = {
    success: boolean;
    errors: unknown[];
    // eslint-disable-next-line camelcase
    internal_errors: unknown[];
    showTimeMachine: boolean;
    serverTime: string;
    metadata: {
        cart: HeaderStandaloneProps['cart'];
        loginState: HeaderStandaloneProps['loginState'];
        seo: EventData['USER_LOADED'];
    };
};
